import { useState, useCallback } from 'react';

const validator = (
  value: [number, number],
  min: number,
  max: number,
): [number, number] => {
  let value0 = value[0] < min ? min : value[0];
  value0 = value0 > max ? max : value0;

  let value1 = value[1] < min ? min : value[1];
  value1 = value1 > max ? max : value1;

  if (value0 > value1) {
    value0 = min;
  }

  return [value0, value1];
};

type Pair = [number, number];

export const useValidatedRangeState = (
  defaultValue: [number, number],
  { min, max }: { min: number; max: number },
): [Pair, (value: Pair) => void] => {
  const [value, setValue] = useState<[number, number]>(
    validator(defaultValue, min, max),
  );

  const validatedSetValue = useCallback(
    (value: [number, number]) => setValue(validator(value, min, max)),
    [min, max],
  );

  return [value, validatedSetValue];
};
